<div class="wrap">
  <div class="wrap__container">
    <div class="container">
      <div class="container__content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
